import React, { useEffect, useState } from 'react';
import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { BaseConfig } from '../BaseConfig';
import { PageType, topLeftMenuProps } from '../../misc/tools';
import TopLeftControlsUI from '../ui/hud/top-left-controls-ui';
import CoreReturnToMainMenuUI from '../../cvp-webgames-core/Components/ui/react/core-return-to-main-menu-ui';

export enum HudActions {
	AdjustBedHeight,
	CallForFiberopticLaryngoscope,
	PreOxygenatePatient,
	// PositionPatient,
	SetupSuction,
	AdministerMedications,
	RepeatSbarInformation,
	AssessAirway,
	VortexAid,
	CallForVortex,
	CallForOORAM
}

export enum HudNPCType {
	respiratoryTherapist,
	nurse,
	physician,
	patient
}

var selectedName = '';
var disabledActions: HudActions[] = [];

const handle508ClickOut = (name?: string)=> {
	var id = (name ?? selectedName) + 'hud-root-button';
	// setFocus(id);
}

var patientSelected = false;
var displayVortex = false;

const HUDUI = (props: UIProperties<HUDUIConfig>) => {
	const [showReturnToMainMenu, setShowReturnToMainMenu] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);
	useEffect(() => {
		(props.parameters as any).onForceUpdate = () => {
			setForceUpdate(!forceUpdate);
		}
	})

	return (
		<div style={{
			zIndex: 10,
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<TopLeftControlsUI id={Tools.generateGuid()} dispatch={null} key={Tools.generateGuid()} parameters={topLeftMenuProps(null, () => {
				setShowReturnToMainMenu(true);
			}, () => {
				if((window as any)['forceEntireUIRefresh']) {
					(window as any)['forceEntireUIRefresh']();
				}
			}, '', '')}></TopLeftControlsUI>

			{showReturnToMainMenu ?<CoreReturnToMainMenuUI id={Tools.generateGuid()} dispatch={null} key={Tools.generateGuid()} parameters={{
				topId: 'return-to-main-menu-content-top',
				bottomId: 'return-to-main-menu-content-bottom', 
				onGoToMainMenuClicked: () => {
					Tools.updateWindow(PageType.MainMenu);
					setShowReturnToMainMenu(false);
				},
				onCancelClicked: () => {
					setShowReturnToMainMenu(false);
				}
			}}></CoreReturnToMainMenuUI> : null}
		</div>
	);
};

export interface HUDUIConfig extends BaseConfig{
}

export default HUDUI;